import React from "react";
import "./LegendItem.scss";

const LegendItem = ({ children, className, color }) => (
  <div className={`legend-item ${className ? className : ""}`}>
    <i className="legend-item__icon" style={{ background: color }} />
    <span className="legend-item__title">{children}</span>
  </div>
);

export default LegendItem;
